import { useEffect, useRef } from "react";

// Simple IntersectionObserver-driven reveal for elegant editorial fade-ups.
export function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("is-visible");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.18, ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [options]);

  return ref;
}
